import moment from 'moment';

export const statusDefaultData = [
    {
        key: 'EPILOG',
        name: 'epiLOG',
        status: 'No information',
        lastReceived: null,
    },
    {
        key: 'PACMAN',
        name: 'Pacman',
        status: 'No information',
        lastReceived: null,
    },
    {
        key: 'PI',
        name: 'PI',
        status: 'No information',
        lastReceived: null,
    },
    {
        key: 'CMMS',
        name: 'CMMS',
        status: 'No information',
        lastReceived: null,
    },
    {
        key: 'POWERPRICE',
        name: 'Power Price',
        status: 'No information',
        lastReceived: null,
    },
    {
        key: 'GRID_FORECAST',
        name: 'Grid Forecast',
        status: 'No information',
        lastReceived: null,
    },
    {
        key: 'GRID',
        name: 'Grid Updates',
        status: 'No information',
        lastReceived: null,
    },
    {
        key: 'WEATHER',
        name: 'Weather Updates',
        status: 'No information',
        lastReceived: null,
    },
    {
        key: 'WEATHER_FORECAST',
        name: 'WeatherQuest',
        status: 'No information',
        lastReceived: null,
    },
    {
        key: 'PERF_METRICS',
        name: 'Performance Metrics',
        status: 'No information',
        lastReceived: null,
    },
];

export const handleStatusData = (systems, d) => {
    const latestTimestamp = d.ts.value;

    let status = '';

    if (!d.connection_active) {
        status = 'No Connection';
    } else if (d.connection_active.value === true) {
        status = 'Operational';
    } else if (d.connection_active.value === false) {
        status = 'Not Operational';
    }

    const normalizedStatusData = {
        key: d.key.value,
        ts: latestTimestamp ? moment.utc(latestTimestamp).valueOf() : null,

        status,
        lastReceived: d.last_ping ? moment.utc(d.last_ping.value).toDate() : null,
    };

    const idx = systems.findIndex((item) => item.key === normalizedStatusData.key);

    if (idx === -1) {
        return systems;
    }

    systems[idx] = { ...systems[idx], ...normalizedStatusData };
    return systems;
};
